import {
  getObject,
} from "@surya-digital/leo-ts-types";
import { SingleChoiceAnswerV1, SingleChoiceAnswerV1DTO } from "../types/singleChoiceAnswerV1";
import { CommonResultBreakdownDetails, CommonResultBreakdownDetailsDTO } from "./commonResultBreakdownDetails";

export interface GridSingleSelectResultV1DTO {
  answer: SingleChoiceAnswerV1DTO;
  commonResultBreakdownDetails: CommonResultBreakdownDetailsDTO;
}

export class GridSingleSelectResultV1 {
  readonly isGridSingleSelectResultV1GridSingleSelectResultV1: boolean = true;

  readonly answer: SingleChoiceAnswerV1;
  readonly commonResultBreakdownDetails: CommonResultBreakdownDetails;


  constructor(
  answer: SingleChoiceAnswerV1, 
  commonResultBreakdownDetails: CommonResultBreakdownDetails
  ) {
    this.answer = answer;
    this.commonResultBreakdownDetails = commonResultBreakdownDetails;
  }

  static fromDTO(dto: GridSingleSelectResultV1DTO): GridSingleSelectResultV1 {
    const answer = SingleChoiceAnswerV1.fromDTO(getObject(dto, "answer", InvalidGridSingleSelectResultV1AnswerError));
    const commonResultBreakdownDetails = CommonResultBreakdownDetails.fromDTO(getObject(dto, "commonResultBreakdownDetails", InvalidGridSingleSelectResultV1CommonResultBreakdownDetailsError));
    return new GridSingleSelectResultV1(
      answer,
      commonResultBreakdownDetails
    );
  }

  toDTO(): GridSingleSelectResultV1DTO {
    const dto: GridSingleSelectResultV1DTO = {
        answer: this.answer.toDTO(),
        commonResultBreakdownDetails: this.commonResultBreakdownDetails.toDTO()
    };
    return dto;
  }
  }

GridSingleSelectResultV1.prototype.toString = function toString(): string {
  return `GridSingleSelectResultV1(answer='${this.answer}',commonResultBreakdownDetails='${this.commonResultBreakdownDetails}')`;
};

export class InvalidGridSingleSelectResultV1Error extends Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGridSingleSelectResultV1Error";
  }
}
export class InvalidGridSingleSelectResultV1AnswerError extends InvalidGridSingleSelectResultV1Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGridSingleSelectResultV1AnswerError";
  }
}

export class InvalidGridSingleSelectResultV1CommonResultBreakdownDetailsError extends InvalidGridSingleSelectResultV1Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGridSingleSelectResultV1CommonResultBreakdownDetailsError";
  }
}
